import {lazy} from "react";

const SearchAutomaticFlow = lazy(() => import("./SearchAutomaticFlow"));
const EditAutomaticFlow = lazy(() => import("./EditAutomaticFlow"));

const automaticFlowRoutes = [
    {
        path: "/automatic-flow",
        element: <SearchAutomaticFlow/>,
    },
    {
        path: "/automatic-flow/new",
        element: <EditAutomaticFlow/>,
    },
    {
        path: "/automatic-flow/:id",
        element: <EditAutomaticFlow/>,
    },
];

export default automaticFlowRoutes;